import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import {
  ApiResponse,
  CountryItem,
  LocationResponse,
  LookupItem,
  LookupResponse,
  StateItem,
} from '../models/lookup.models';
import { ErrorHandlingService } from './error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private readonly baseUrl = environment.apiUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandler: ErrorHandlingService
  ) {}

  getLookupValue(type: string, searchTerm: string): Observable<LookupItem[]> {
    const url = `${this.baseUrl}/ApplicationLookup`;
    const params = {
      TypeName: type,
      SearchTerm: searchTerm,
    };

    return this.http.get<LookupResponse>(url, { params }).pipe(
      map(response => response.result),
      catchError(error => this.errorHandler.handleError(error))
    );
  }

  getLocationByPostalCode(postalCode: string): Observable<LocationResponse> {
    const url = `${this.baseUrl}/ApplicationLookup/get-location-by-postal-code`;
    return this.http
      .get<ApiResponse<LocationResponse>>(url, { params: { postalCode } })
      .pipe(
        map(response => response.result),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  getCountries(): Observable<CountryItem[]> {
    const url = `${this.baseUrl}/ApplicationLookup/get-country-list`;
    return this.http.get<ApiResponse<CountryItem[]>>(url).pipe(
      map(response => response.result),
      catchError(error => this.errorHandler.handleError(error))
    );
  }

  getStates(countryName: string): Observable<StateItem[]> {
    const url = `${this.baseUrl}/ApplicationLookup/get-state-list`;
    return this.http
      .get<ApiResponse<StateItem[]>>(url, { params: { countryName } })
      .pipe(
        map(response => response.result),
        catchError(error => this.errorHandler.handleError(error))
      );
  }
}
